import { render } from "./TechCarousel.vue?vue&type=template&id=1e15d910&scoped=true"
import script from "./TechCarousel.vue?vue&type=script&lang=js"
export * from "./TechCarousel.vue?vue&type=script&lang=js"

import "./TechCarousel.vue?vue&type=style&index=0&id=1e15d910&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e15d910"]])

export default __exports__